import { Modal } from "react-bootstrap";
import { Button } from "../button";

import { ViewDigitalSignatureModalProps } from "./RequestDigitalSignatureModal.types";
import { GenericForm } from "../generic-form";
import { EditViewDigitalSignatureRequestDTO } from "./ViewDigitalSignatureModal.types";
import { useViewDigitalSignatureModal } from "./useViewDigitalSignatureModal";

export const ViewDigitalSignatureModal = ({
  isVisible,
  onDismiss,
  fields,
  onDelete,
  handleEdit,
  editingSignature,
}: ViewDigitalSignatureModalProps) => {
  const { t, showDeleteOption, hasChanged, onValueChange } = useViewDigitalSignatureModal(
    fields,
    isVisible
  );

  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          {t("DOCUMENTS.DIGITAL_SIGNATURE_INFO")}
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        {/* <FormPreview metaDataForm={fields} /> */}
        <GenericForm
          form={fields || {}}
          onSubmit={(data) => {
            const editData: EditViewDigitalSignatureRequestDTO = {
              email: String(data.email),
              authorizedSignatory: Number(data.authorizedSignatory) || 0,
              sendEmailToCustomer: data.sendEmailToCustomer as boolean,
            };
            handleEdit(editData);
          }}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={editingSignature}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
                disabled={!hasChanged}
              >
                {t("EDIT_REQUEST_BUTTON")}
              </Button>
            </div>
          )}
          onValuePropChange={(key, value) => {
            onValueChange(String(key), value);
          }}
        />
        {showDeleteOption && (
          <Button onClick={onDelete} className="btn btn-danger w-100 mt-4">
            {t("DOCUMENTS.DELETE_DIGITAL_SIGNATURE_REQUEST")}
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};
